import React from 'react';
import { GraduationCap, BookText, Globe, Award } from 'lucide-react';
import dinosaurLogo from '../../dinosaur.png';

export const Footer: React.FC = () => {
  const testPrepPrograms = [
    { name: 'IELTS Coaching', url: 'https://firstacademy.in/ielts', icon: BookText },
    { name: 'SAT Preparation', url: 'https://firstacademy.in/sat', icon: GraduationCap },
    { name: 'GRE Training', url: 'https://firstacademy.in/gre', icon: Award },
    { name: 'TOEFL Prep', url: 'https://firstacademy.in/toefl', icon: Globe },
    { name: 'PTE Coaching', url: 'https://firstacademy.in/pte', icon: BookText },
    { name: 'OET Training', url: 'https://firstacademy.in/oet', icon: BookText },
    { name: 'DET (Duolingo)', url: 'https://firstacademy.in/det', icon: Globe },
  ];

  const studyAbroadServices = [
    { name: 'Study Abroad Consulting', url: 'https://firstacademy.in/studyabroad' },
    { name: 'UG Admissions', url: 'https://firstacademy.in/ug' },
    { name: 'Masters Programs', url: 'https://firstacademy.in/masters' },
  ];

  const resources = [
    { name: 'Universities', url: '/explore/universities' },
    { name: 'Programs', url: '/explore/programs' },
    { name: 'Countries', url: '/explore/countries' },
    { name: 'Take Quiz', url: '/quiz' },
  ];

  return (
    <footer className="bg-slate-900 text-slate-300 mt-auto">
      <div className="container mx-auto px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Brand Section */}
          <div>
            <div className="flex items-center gap-2.5 mb-4">
              <img
                src={dinosaurLogo}
                alt="AskDino Logo"
                className="w-10 h-10 object-contain"
              />
              <div>
                <h3 className="text-xl font-bold text-white">AskDino</h3>
                <p className="text-xs text-slate-400">by FirstAcademy</p>
              </div>
            </div>
            <p className="text-sm text-slate-400 mb-4">
              Your complete guide to finding the perfect university program and preparing for success.
            </p>
            <p className="text-sm text-slate-500">
              © 2025 FirstAcademy. All rights reserved.
            </p>
          </div>

          {/* Test Prep Programs */}
          <div>
            <h3 className="text-lg font-bold text-white mb-4">Test Preparation</h3>
            <ul className="space-y-2">
              {testPrepPrograms.map((program) => (
                <li key={program.name}>
                  <a
                    href={program.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-sm text-slate-400 hover:text-primary transition-colors flex items-center gap-2"
                  >
                    <program.icon className="h-4 w-4" />
                    {program.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Study Abroad Services */}
          <div>
            <h3 className="text-lg font-bold text-white mb-4">Study Abroad</h3>
            <ul className="space-y-2">
              {studyAbroadServices.map((service) => (
                <li key={service.name}>
                  <a
                    href={service.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-sm text-slate-400 hover:text-primary transition-colors"
                  >
                    {service.name}
                  </a>
                </li>
              ))}
            </ul>
            <div className="mt-6">
              <h4 className="text-sm font-semibold text-white mb-2">Additional Programs</h4>
              <ul className="space-y-2">
                <li>
                  <a
                    href="https://firstacademy.in/spokenenglish"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-sm text-slate-400 hover:text-primary transition-colors"
                  >
                    English Training
                  </a>
                </li>
                <li>
                  <a
                    href="https://firstacademy.in/custom"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-sm text-slate-400 hover:text-primary transition-colors"
                  >
                    Corporate Training
                  </a>
                </li>
              </ul>
            </div>
          </div>

          {/* Resources */}
          <div>
            <h3 className="text-lg font-bold text-white mb-4">Resources</h3>
            <ul className="space-y-2">
              {resources.map((resource) => (
                <li key={resource.name}>
                  <a
                    href={resource.url}
                    className="text-sm text-slate-400 hover:text-primary transition-colors"
                  >
                    {resource.name}
                  </a>
                </li>
              ))}
            </ul>
            <div className="mt-6">
              <h4 className="text-sm font-semibold text-white mb-2">Connect</h4>
              <ul className="space-y-2">
                <li>
                  <a
                    href="https://firstacademy.in/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-sm text-slate-400 hover:text-primary transition-colors"
                  >
                    FirstAcademy Website
                  </a>
                </li>
                <li>
                  <a
                    href="/privacy"
                    className="text-sm text-slate-400 hover:text-primary transition-colors"
                  >
                    Privacy Policy
                  </a>
                </li>
                <li>
                  <a
                    href="/terms"
                    className="text-sm text-slate-400 hover:text-primary transition-colors"
                  >
                    Terms of Service
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
